import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { isBootstrapIdentityEnabled } from '../bootstrap-identity.utils';

export const bootstrapIdentityGuard: CanActivateFn = () => {
	if (isBootstrapIdentityEnabled()) {
		return true;
	}

	return inject(Router).createUrlTree(['/sign-out']);
};
